<script setup lang="ts">
defineProps({
    label: {
        type: String,
        default: ''
    },
    route: {
        type: String,
        default: null
    }
})
</script>
<template>
    <router-link :to="route">
        <a class="inline-block text-sm text-primary align-baseline hover:text-primary-hover">
            {{ label }}
        </a>
    </router-link>
</template>
<style scoped></style>
